module.exports = __webpack_public_path__ + "static/media/unicorn_logo.dbc5c14a.png";